import { render, staticRenderFns } from "./CouponRuleFees.vue?vue&type=template&id=fd0cd1c8&scoped=true"
import script from "./CouponRuleFees.vue?vue&type=script&lang=js"
export * from "./CouponRuleFees.vue?vue&type=script&lang=js"
import style0 from "./CouponRuleFees.vue?vue&type=style&index=0&id=fd0cd1c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0cd1c8",
  null
  
)

export default component.exports